export default {
  "foot": {
    "title": "Century Games 플레이어",
    "p1": "ID를 입력하고 결제를 진행하세요. 결제 금액은 연동된 계정에 업데이트됩니다. 표시되지 않는 경우, 게임을 다시 로딩한 뒤 확인하시고 필요한 경우 고객센터로 문의하실 수 있습니다.",
    "p2": "문의 사항이 있으시면 저희 고객 센터로 연락 주세요. 감사합니다!",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "서비스 이용약관",
    "policy": "개인정보보호정책",
    "descriptionTitle": "사용 방법이 무엇인가요?"
  },
  "accept": {
    "title": "이 웹사이트는 원활한 브라우징 경험을 위해 쿠키를 사용합니다. 자세한 사항은 저희 웹사이트 <a href=\"https://www.centurygames.com/ko/privacy-policy/\" style=\"color: #58a8a5;\">개인정보보호정책</a>을 참고하세요. 이 사이트에서 계속하면 자동적으로 귀하의 장치에 쿠키 및 정보 저장에 동의하게 됩니다.",
    "decline": "거절",
    "accept": "수락"
  },
  "game": {
    "inapptext": "혹은 게임 로그인하기",
    "loginfail": "로그인 실패",
    "logintip": "게임 승인에 실패하는 경우, 게임을 최신 버전으로 업데이트하거나 다른 브라우저에서 다시 시도하세요.",
    "reloadmsg": "다시 로딩'을 탭하여 로그인 결과를 확인하세요.",
    "reload": "다시 로딩",
    "appnotice": "게임 어플을 통해 로그인하고 싶으신 경우, 외부 브라우저를 사용하여 스토어를 열어주세요.",
    "changeaccount": "정말로 계정에서 로그아웃하시겠습니까?",
    "login": "로그인",
    "notice": "공지",
    "confirm": "확인",
    "loginuserid": "유저 ID",
    "palceholder": "유저 ID를 입력하세요",
    "okbtn": "OK",
    "loginbtn": "게임으로 로그인",
    "changebtn": "혹은 유저 ID로 로그인",
    "useTitle": "계정",
    "checkBtn": "확인",
    "findid": "유저 ID를 잃어버리셨나요?",
    "checktext": "ID는 설정에서 찾을 수 있습니다. 물음표를 탭해 자세한 설명을 확인하세요.",
    "username": "별칭:",
    "userId": "유저 ID:",
    "packageTitle": "충전 금액",
    "edit": "편집",
    "paymentTitle": "결제 방식",
    "total": "총",
    "goPay": "지금 플레이",
    "noSelectPackageTips": "금액을 선택하지 않으셨어요",
    "payFail": "결제 실패",
    "camelPayfail": "결제 실패",
    "payFailTips1": "Adyen 고객 센터에 연락하세요",
    "payFailTips2": "PayPal 고객 센터에 연락하세요",
    "paySuccess": "결제 성공",
    "paySuccessTips2": "고객 센터에 문의하기 전 먼저 게임을 다시 로딩해 보세요!",
    "camelPaySuccess": "결제 성공",
    "transactionId": "결제 ID",
    "paySuccessTips": "아이템 도착이 지연될 수 있습니다. 잠시만 기다려 주세요.",
    "deliveryFail": "상품 발송 실패",
    "deliveryFailTips": "고객 센터에 문의하세요",
    "orderTitle": "주문 정보",
    "paidWith": "결제 방식",
    "orderID": "결제 ID",
    "payStatus": "결제 현황",
    "orderTotal": "총 금액",
    "transactionDate": "결제 날짜",
    "goOnPay": "다시 구매하기",
    "getInvoice": "영수증",
    "camelDeliveryFail": "상품 발송 실패",
    "confirmOrder": "주문 확인",
    "confirmFollow": "아래 정보를 확인해 주세요:",
    "nickname": "별칭",
    "packageName": "아이템",
    "totalPayment": "총 금액",
    "confirmPayWith": "결제 방식",
    "confirmAndGoOn": "확인 & 결제 진행하기",
    "orderCancel": "취소",
    "getInvoiceTitle": "이메일로 발송",
    "getInvoiceTips": "이메일로 영수증을 수신하고 싶으신 경우, 이메일 주소를 적어주세요.",
    "getInvoiceTips1": "영수증을 받을 이메일 주소를 입력하세요",
    "getInvoiceTips2": "이메일 주소 정보 수집 및 저장에 동의",
    "getInvoiceTips3": "할인, 프로모션 등 마케팅 이메일 수신에 동의",
    "invoiceSend": "발송",
    "sendSuccess": "영수증 발송 성공",
    "id404": "존재하지 않는 유저 ID",
    "packageLoadingText": "상점 아이템 업데이트 중...",
    "taxTips": "세금 포함 가격",
    "adyenTips": "결제 서비스는 네덜란드 중앙은행의 감독을 받으며 은행 면허를 보유한 Adyen이 제공합니다. 인증서에 대한 문의는 <a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a> 링크를 참고하시기 바랍니다. 정보 보호 방식은 <a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and-disclaimer/privacy-policy</a>에서 확인하실 수 있습니다.",
    "paypalTips": "PayPal이 제공하는 결제 서비스입니다. 정보 보호 방식은 <a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a>에서 확인하시기 바랍니다.",
    "switchCountryTips": "${servercountry}(으)로 지정되어 있습니다. 국가/지역 및 통화 단위를 변경하시겠습니까?",
    "paypalBtn": "카드로 결제하기",
    "paypalOr": "혹은",
    "paypalCard1": "카드 소지자 성명 (선택 사항)",
    "paypalCard2": "카드 번호",
    "checkUserID": "링크",
    "success": "성공",
    "changeCurrencyContent": "국가/지역 및 통화 단위를 게임 내 설정 ${servercountry}에 따라 변경하시겠습니까?",
    "productDescription": "농장 머니는 현금과 동등하게 게임 내 패키지 및 딜을 구매할 수 있는 통화 단위입니다.",
    "payButton": "결제하기",
    "userIdNotice": "게임 계정과 연동할 유저 ID를 먼저 입력하세요",
    "account": "계정",
    "card": "카드",
    "notification": "계정과 연동할 유저 ID를 입력한 후, 원하는 아이템을 선택하여 선호하는 결제 방식으로 구매를 진행하세요. 게임을 다시 로딩하면 구매한 아이템이 계정에 표시되어 사용하실 수 있습니다.\n\n자세한 사항은 게임 내 고객센터로 연락 주시기 바랍니다.",
    "rongluRank": "용광로 레벨:",
    "tips": "사용 방법?",
    "checkTIps1": "<a :href=\"policyUrl\">\"개인정보보호정책\"</a>, <a :href=\"serviceURl\">\"이용약관\"</a> 및 <a :href=\"paymentURl\">\"결제 이용약관\"</a>을 모두 숙지하였으며 동의합니다.",
    "checkTIps2": "읽고 동의하시기 바랍니다",
    "selectTips": "(게임 내 결제 시 사용한 가장 최근 통화 단위를 선택합니다)",
    "koPayTips": "결제 카드가 해외원화결제 서비스 (DCC)를 이용한 경우 수수료가 발생하며 해당 비용은 본 웹사이트가 아닌 제삼자 대리점에서 부과합니다.",
    "PayTips": ""
  },
  "invoice": {
    "title": "영수증",
    "transactionId": "결제 ID",
    "transactionDate": "결제 날짜",
    "totalAmount": "총 금액",
    "paymentMethod": "결제 방식",
    "description": "세부 사항",
    "game": "게임",
    "quantity": "수량",
    "price": "가격",
    "amount": "총액",
    "total": "총액",
    "footTitle": "기타",
    "footContent": "Century Games를 이용해 주셔서 감사합니다!",
    "button1": "영수증 받기",
    "button2": "영수증 없이 돌아가기",
    "giveupInvoice": "이 주문의 영수증이 발행되지 않습니다. 확인하시겠습니까?"
  },
  "payment": {
    "card": "신용/직불 카드",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "국가/지역",
    "Africa": "아프리카",
    "America": "아메리카",
    "Asia": "아시아",
    "Europe": "유럽",
    "Oceania": "오세아니아",
    "ZA": "남아프리카",
    "US": "미국",
    "HK": "홍콩, 중국",
    "JP": "일본",
    "KR": "한국",
    "SG": "싱가포르",
    "SA": "사우디아라비아",
    "IQ": "이라크",
    "TW": "타이완, 중국",
    "TH": "태국",
    "GB": "영국",
    "AU": "호주",
    "countryLanguage1": "언어",
    "AE": "아랍에미리트",
    "DE": "독일",
    "PT": "포루투갈",
    "RU": "러시아",
    "ES": "스페인",
    "CH": "스위스",
    "TR": "튀르키예",
    "KW": "쿠웨이트",
    "QA": "카타르",
    "PL": "폴란드",
    "ID": "인도네시아",
    "IT": "이탈리아",
    "IN": "인도",
    "FR": "프랑스",
    "CA": "캐나다",
    "NL": "네덜란드",
    "AT": "오스트리아",
    "RS": "세르비아",
    "SE": "스웨덴",
    "MY": "말레이시아",
    "BE": "벨기에",
    "DK": "덴마크",
    "FI": "핀란드",
    "PH": "필리핀",
    "NO": "노르웨이",
    "BR": "브라질",
    "NZ": "뉴질랜드",
    "UA": "우크라이나",
    "RO": "로마니아"
  },
  "extra_info": {
    "kingdom": "소속 왕국: "
  },
  "adyen": {
    "note": "결제 서비스는 국내 및 해외 카드 결제를 모두 지원하는 국제 신용카드 단체로부터 최고 수준의 PCI-DSS 인증을 받은 Adyen에서 제공합니다.",
    "note2": "주의: \"다음 결제를 위해 이 수단 저장\"을 선택하면 현재 브라우저 내 결제 카드 정보를 저장하여 추후에 쉽게 결제를 진행할 수 있습니다."
  },
  "pay": {
    "error1": "오류가 발생한 경우, 나중에 다시 시도하거나 다른 결제 방식을 사용해 주시기 바랍니다. 문의 사항은 고객 센터로 연락 주세요."
  },
  "meta": {
    "title": "패밀리 팜 어드벤처 상점",
    "description": "패밀리팜 어드벤처 상점은 패밀리팜 어드벤처 공식 상점으로 할인된 가격으로 패키지 및 아이템을 확인하실 수 있는 곳입니다.",
    "keywords": "농장, 경작, 마켓, 업그레이드, 탐험, 지도, 캐릭터, 레벨, 시뮬레이션, 전략, 구매, 상점, 충전, 결제"
  }
};


// WEBPACK FOOTER //
// ./src/lang/KO.js